import {useLogoutCommand} from "./useLogoutCommand";
import ICommand from "./ICommand";
import {useSetHostnameCommand} from "./useSetHostnameCommand";
import {useHostnameCommand} from "./useHostnameCommand";
import {useLoginCommand} from "./useLoginCommand";
import {useRegisterCommand} from "./useRegisterCommand";
import {useClsCommand} from "./useClsCommand";
import {useMembersCommand} from "./useMembersCommand";
import {useSwitchUserCommand} from "./useSwitchUserCommand";
import {useAddUserCommand} from "./useAddUserCommand";
import {useDelUserCommand} from "./useDelUserCommand";
import {useChessCommand} from "./useChessCommand";
import {useLsCommand} from "./useLsCommand";
import {useViCommand} from "./useViCommand";
import useMessageLogic from "../logic/useMessageLogic";
import {useAppSelector} from "../hooks";
import {selectUser} from "../redux/auth";

export const useCommands = () => {
  const messages = useMessageLogic()
  const user = useAppSelector(selectUser)

  const registerCommand = useRegisterCommand()
  const loginCommand = useLoginCommand()
  const logoutCommand = useLogoutCommand()
  const hostnameCommand = useHostnameCommand()
  const setHostnameCommand = useSetHostnameCommand()
  const clsCommand = useClsCommand()
  const membersCommand = useMembersCommand()
  const switchUserCommand = useSwitchUserCommand()
  const addUserCommand = useAddUserCommand()
  const delUserCommand = useDelUserCommand()
  const lsCommand = useLsCommand()
  const viCommand = useViCommand()
  const chessCommand = useChessCommand()

  //hidden commands
  const commands: ICommand[] = [
    registerCommand,
    loginCommand,
    hostnameCommand,
    setHostnameCommand,
    clsCommand,
    membersCommand,
    switchUserCommand,
    addUserCommand,
    delUserCommand,
    lsCommand,
    viCommand,
    chessCommand,
    logoutCommand
  ]

  const availableCommands = commands.filter((c) => user || !c.secure)

  //Chaining command (using && to run multiple commands
  const chainingCommand: ICommand = {
    hidden: true,

    help(filter: string | undefined): string {
      return "";
    },

    matches(msg: string): boolean {
      if (msg.includes(' && ')) {
        const commandParts = msg.split(' && ').map((c) => c.trim())

        //if any of these are a normal command, we're gonna process it, otherwise it's a normal message with a &&

        const validPart = commandParts.find((p) => find(p))
        return !!validPart
      } else {
        return false
      }
    },

    async process(msg: string): Promise<void> {
      const commandParts = msg.split(' && ').map((c) => c.trim())

      for (const command of commandParts) {
        await run(command)
      }
    }
  }

  // Show help
  const helpCommand: ICommand = {
    help(filter: string | undefined): string {
      return "- help\t\t\t\t\t:: the command you just typed";
    },

    matches(msg: string): boolean {
      return msg.toLowerCase().trim() === 'help';
    },

    async process(msg: string): Promise<void> {
      let helpString = 'help - systemic (v1.1):\n';
      for (const command of availableCommands) {
        if (command.hidden) {
          continue;
        }

        const helpMessage = command.help(undefined)
        if (helpMessage) {
          helpString += helpMessage + '\n'
        }
      }

      messages.addNoticeMessage(helpString)
    }
  }


  //you go first!
  availableCommands.unshift(chainingCommand)

  //help command
  availableCommands.push(helpCommand)

  const find = (cmd: string): ICommand|undefined => {
    return availableCommands.find((c) => c.matches(cmd))
  }

  const run = async (cmd: string): Promise<boolean> => {
    const command = find(cmd)

    if (command) {
      await command.process(cmd)
      return true
    } else {
      setTimeout(() => {
        messages.addUserMessage(cmd)
      }, 100)
      return false
    }
  }

  return {
    commands: availableCommands,
    run,
    find
  }
}